import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,
  recette: true,
  formbricksEnv: 'clommrzcdrhl4q70fhl0h76ux',
  apiUrl: 'https://api.recette.upbycellance.com/api', // dev env
  apiKeyGoogleMap: 'AIzaSyD7uxV-zbxKj0PPbclebn-JIJmJ4P-2z1A',
  metricsUrl: 'https://api.dev.metrics.upbycellance.com',
  metricsToken: 'QF3DEz4LSoS6mRt8JiYJxmAgrvmGqtuh3MzTep4VTg6kuD1gYGO20K0OkcpckC3Z'
};
